import FoodImage1 from '../images/foodImages/pasta/Food_img1.jpg';

const PastaItems = [
  { id: 1, name: '上天給的禮物', price: 230, description: '口感清新，營養滿分的蔬菜', image: FoodImage1 },
  { id: 2, name: '敘月招牌烤雞腿', price: 280, description: '香氣四溢，外脆內嫩的招牌烤雞', image: FoodImage1 },
  { id: 3, name: '不被炒魷魚', price: 320, description: '鮮美魷魚，搭配獨特醬汁，味道十足', image: FoodImage1 },
  { id: 4, name: '真的很蝦ㄟ', price: 350, description: '新鮮大蝦，搭配香濃醬汁，鮮嫩可口', image: FoodImage1 },
  {
    id: 5,
    name: '彈牙豬(松阪豬)',
    price: 380,
    description: '細緻多汁的松阪豬，彈牙口感每一口都驚喜',
    image: FoodImage1,
  },
  { id: 6, name: '鮭魚', price: 380, description: '滑嫩鮭魚，完美搭配的香草風味，營養美味', image: FoodImage1 },
  { id: 7, name: '非常牛(牛板腱)', price: 400, description: '精選牛板腱，肉質鮮嫩，滿口肉香', image: FoodImage1 },
  { id: 8, name: '海派(綜合海鮮)', price: 420, description: '鮮美海鮮大集合，海味十足每一口都滿足', image: FoodImage1 },
  { id: 9, name: '鮮嫩巴沙魚', price: 280, description: '入口即化的巴沙魚，口感柔嫩，滋味無窮', image: FoodImage1 },
];

export default PastaItems;
